<div class="dialog-main__container">
  <div class="dialog-header__container">
    <h3 class="dialog-header__title">Promotion</h3>
  </div>
  <div class="dialog-content__container">
    <form [formGroup]="promotionForm">
      <div class="container">
        <div class="row">
          <div class="col-left">
            <div class="mb-16 mt-16 flex_container">
              <label
                appMarkAsterisk
                [formGroup]="promotionForm"
                [controlName]="'date'"
                [touched]="promotionForm.get('date')!.touched"
                >Date</label
              >
              <div class="date_input">
                <app-datepicker
                  [iconLeft]="true"
                  formControlName="date"
                  [staticPropery]="true"
                  (datepickerOpened)="isDatePickerOpened = $event"
                ></app-datepicker>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('date', promotionForm) &&
                    promotionForm.get('date')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
            <div class="mb-16 flex_container">
              <label
                class="label-input"
                appMarkAsterisk
                [formGroup]="promotionForm"
                [controlName]="'hr'"
                [touched]="promotionForm.get('hr')!.touched"
                >HR</label
              >
              <div
                class="input-wrapper dropdown-wrapper ml29"
                [class.zero-index]="isDatePickerOpened"
              >
                <app-dropdown
                  [items]="this.data.dropdowns.HR"
                  formControlName="hr"
                ></app-dropdown>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('hr', promotionForm) &&
                    promotionForm.get('hr')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
            <div class="mb-16 flex_container">
              <label
                class="label-input"
                appMarkAsterisk
                [formGroup]="promotionForm"
                [controlName]="'pm'"
                [touched]="promotionForm.get('pm')!.touched"
                >PM</label
              >
              <div
                class="input-wrapper dropdown-wrapper ml29"
                [class.zero-index]="isDatePickerOpened"
              >
                <app-dropdown
                  [items]="this.data.dropdowns.PM"
                  formControlName="pm"
                ></app-dropdown>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('pm', promotionForm) &&
                    promotionForm.get('pm')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
            <div class="mb-16 flex_container">
              <label
                class="label-input"
                appMarkAsterisk
                [formGroup]="promotionForm"
                [controlName]="'status'"
                [touched]="promotionForm.get('status')!.touched"
                >Status</label
              >
              <div
                class="input-wrapper dropdown-wrapper ml29"
                [class.zero-index]="isDatePickerOpened"
              >
                <app-dropdown
                  [items]="this.data.dropdowns.ReviewStatus"
                  formControlName="status"
                ></app-dropdown>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('status', promotionForm) &&
                    promotionForm.get('status')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
          </div>
          <div class="col-custom">
            <div class="mb-16 mt-16 flex_container">
              <label
                class="label-input"
                appMarkAsterisk
                [formGroup]="promotionForm"
                [controlName]="'level'"
                [touched]="promotionForm.get('level')!.touched"
                >New level</label
              >
              <div class="input-wrapper input-wrapper-wide ml29">
                <app-dropdown
                  [items]="this.data.dropdowns.QualificationLevel"
                  formControlName="level"
                ></app-dropdown>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('level', promotionForm) &&
                    promotionForm.get('level')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
            <div class="mb-16 flex_container">
              <label
                class="label-input"
                appMarkAsterisk
                [formGroup]="promotionForm"
                [controlName]="'department'"
                [touched]="promotionForm.get('department')!.touched"
                >Department</label
              >
              <div
                class="input-wrapper input-wrapper-wide ml29"
                [class.zero-index]="isDatePickerOpened"
              >
                <app-dropdown
                  [items]="this.data.dropdowns.Department"
                  formControlName="department"
                  (change)="onDepartmentChanged()"
                ></app-dropdown>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('department', promotionForm) &&
                    promotionForm.get('department')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
            <div *ngIf="isDeliveryDepartment" class="mb-16 flex_container">
              <label
                class="label-input"
                appMarkAsterisk
                [formGroup]="promotionForm"
                [controlName]="'subDepartment'"
                [touched]="promotionForm.get('subDepartment')!.touched"
                >Sub department</label
              >
              <div
                class="input-wrapper input-wrapper-wide"
                [class.zero-index]="isDatePickerOpened"
              >
                <app-dropdown
                  [items]="subDepartment"
                  formControlName="subDepartment"
                  (change)="onSubDepartmentChanged()"
                ></app-dropdown>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('subDepartment', promotionForm) &&
                    promotionForm.get('subDepartment')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
            <div *ngIf="isDepartmentSelected" class="mb-16 flex_container">
              <label
                class="label-input"
                appMarkAsterisk
                [formGroup]="promotionForm"
                [controlName]="'position'"
                [touched]="promotionForm.get('position')!.touched"
                >Position</label
              >
              <div
                class="input-wrapper input-wrapper-wide ml29"
                [class.zero-index]="isDatePickerOpened"
              >
                <app-dropdown
                  [items]="this.availablePositions"
                  formControlName="position"
                  [countVisibleItems]="5"
                  (change)="checkPositionRequirements()"
                ></app-dropdown>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('position', promotionForm) &&
                    promotionForm.get('position')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
            <div *ngIf="isTechStackVisible" class="mb-16 flex_container">
              <label class="label-input">Tech stack</label>
              <div
                class="input-wrapper input-wrapper-wide ml29"
                [class.zero-index]="isDatePickerOpened"
              >
                <app-dropdown
                  [items]="this.data.dropdowns.StackTechnologies"
                  formControlName="stackTechnology"
                ></app-dropdown>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col">
            <label
              appMarkAsterisk
              [formGroup]="promotionForm"
              [controlName]="'comment'"
              [touched]="promotionForm.get('comment')!.touched"
              >Comment</label
            >
            <div class="input__wrapper">
              <textarea
                formControlName="comment"
                class="input__basic input__textarea"
                placeholder=" "
              ></textarea>
              <app-error-field
                [displayError]="
                  promotionForm.get('comment')!.hasError('wordCount')
                "
                [errorMessage]="'Max field length = 400 words'"
              ></app-error-field>
            </div>
          </div>
          <div class="col mt10">
            <button
              *ngIf="!promotionForm.controls['file']?.value"
              class="button button__lightblue"
              (click)="attachLink()"
            >
              Add document
            </button>
            <div class="link-box">
              <a [href]="promotionForm.controls['file'].value" target="_blank"
                ><img
                  *ngIf="promotionForm.controls['file']?.value"
                  class="link-box__attached_doc icon"
                  src="assets/icons/svg/attached_document/normal.svg"
                  alt="link"
              /></a>
              <div class="link-box__docs">
                <i
                  *ngIf="promotionForm.controls['file']?.value"
                  class="icon-close icon blue"
                  (click)="deleteDocLink()"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="row justify-content-end dialog-button__container pt-3">
    <div class="col-auto p-0">
      <button class="button button__save add-margin" (click)="saveData()">
        Save
      </button>
      <button class="button button__cancel" (click)="cancelSave()">
        Cancel
      </button>
    </div>
  </div>

  <img
    class="interview__trash icon"
    src="assets/icons/svg/trash/ion_trash-bin.svg"
    alt="trash"
    (click)="deletePromotion()"
    *ngIf="!isCreate"
  />
</div>
